import React, { useEffect, useState } from 'react';
import { subscribeToToastAnnouncements } from './createToast';
import { VisuallyHidden } from 'components/core';

// Mirrors toast text for contexts where the ToastContainer's live region is
// aria-hidden, e.g. when a modal dialog is showing.
export const ToastAnnouncement = () => {
  const [announcement, setAnnouncement] = useState<{
    id: number;
    message: string;
  }>();

  useEffect(
    () =>
      subscribeToToastAnnouncements((message) =>
        setAnnouncement((previous) => ({
          id: (previous?.id ?? 0) + 1,
          message,
        }))
      ),
    []
  );

  return (
    <VisuallyHidden component="div" role="status" aria-live="polite">
      {announcement && (
        // Remounting via key re-inserts the text node so screen readers
        // announce a repeat of the same message.
        <span key={announcement.id}>{announcement.message}</span>
      )}
    </VisuallyHidden>
  );
};
